export default __webpack_public_path__ + "static/media/10.54cad84a.jpeg";